<script setup lang="ts">
import type { BaseButtonProps } from "~/types/BaseButton";

const props = defineProps<BaseButtonProps>();

const platformStore = usePlatformStore();
const isFrameTheGame = computed(() => platformStore.isFrameTheGame);
</script>

<template>
  <BaseButtonFTG
    v-if="isFrameTheGame"
    v-bind="props"
  >
    <slot />
  </BaseButtonFTG>
  <BaseButtonMWS
    v-else
    v-bind="props"
  >
    <slot />
  </BaseButtonMWS>
</template>
